import { Component, ElementRef, inject, OnDestroy, OnInit, Input, computed, output, viewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { map, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from '../../classes';
import { AuthService, OrganizationService, OrgSelectionService, NoticeCenterService } from "../../services";
import { Claims, Market } from '../../types';
import { FormsModule } from '@angular/forms';
import { BadgeModule } from 'primeng/badge';

@Component({
    selector: 'subnav',
    templateUrl: './subnav.component.html',
    styleUrls: ['./subnav.component.scss'],
    standalone: true,
  imports: [FormsModule, RouterLink, BadgeModule]
})
export class SubnavComponent extends UnsubscribeOnDestroy implements OnInit, OnDestroy {
    private route = inject(ActivatedRoute);
    private authService = inject(AuthService);
    private orgSelectionService = inject(OrgSelectionService);
    private noticeCenterService = inject(NoticeCenterService);
    private orgService = inject(OrganizationService);
    private router = inject(Router);
    
    marketList: Market[];
    market: Market;
    displayName: string = "";
    userOrgs: string = "";    
    public showNotificationSidebar = false;
    readonly toggleNotificationSidebar = output<boolean>();
    readonly marketComponent = viewChild<ElementRef>("mkt");
    public userHasNotices = computed(()=> this.noticeCenterService.hasNotices())


  constructor() {
        super();
    }

  ngOnInit() {

        this.orgSelectionService.selectedMarket
            .pipe(
                takeUntil(this.ngUnsubscribe$),
                tap(() => this.orgService.notifyMarketsChanged),
                switchMap((selectedMarket) =>
                    this.authService.whenAccessTokenReady().pipe(
                        take(1),
                        switchMap(() => this.orgService.getActiveMarkets()),
                        map((markets) => ({ selectedMarket, markets }))
                    )
                )
            )
            .subscribe(({ selectedMarket, markets }) => {
                //Assign Token properties - Display Name & User Orgs
                this.displayName = this.authService.getClaimValue(Claims.userDisplayName);
                this.userOrgs = this.authService.getClaimValue(Claims.userOrgs);

             
                //Add azureGUID to Session Storage for WhatFix
                if (!sessionStorage.getItem("azureGUID")) {
                  sessionStorage.setItem("azureGUID", this.authService.getClaimValue<string>(Claims.azureGUID));                 
                }

                //Assign Market List - Use only User Orgs if assigned. If none are assigned, use full Market List
                if (this.userOrgs.length > 0) {
                    this.marketList = markets.filter((mkt) => this.userOrgs.indexOf(mkt.orgId.toString()) > -1);
                } else {
                    this.marketList = markets;
                }                
                //Assign Selected Market - Use current Selected Market if the User is assigned to that Org. If not, then use the first Market in the Market List
                if (this.userOrgs.length === 0 || this.userOrgs.indexOf(selectedMarket.orgId.toString()) > -1) {
                    this.market = selectedMarket;
                } else {
                    this.market = this.marketList[0];
                    this.orgSelectionService.selectMarket(this.market);
                }
            });
    }

    openNotificationSidebar() {
      this.toggleNotificationSidebar.emit(true);
    }

    onNotificationSidebarClose() {
      this.toggleNotificationSidebar.emit(false);
    }

    selectedMarketChanged(market: string): void {
        this.orgSelectionService.selectMarket(market);
    }
}
